import React from "react";
import { Card, CardContent } from "./ui/card";
import coachpic from "src/components/ui/images/coach.jpg"


const coaches = [
  {
    name: "Coach Rene AKA “Coach Takis”",
    title: "Head Coach",
    image: coachpic, // ✅ make sure this is inside public/images/
    description:
      "Coach Rene brings real-world experience, passion, and personal dedication to the ring. He's trained under world-renowned boxing coaches across the U.S., including Team Benavidez and Salas Boxing Academy.",
    specialties: [
      "Kids & Teens Training",
      "Adults of All Levels",
      "Amateur & Pro Fighters",
      "Competition Preparation",
    ],
  },
];

export default function CoachesSection() {
  return (
    <section id="coaches" className="py-20 bg-black">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-white mb-4">Meet Our Coach</h2>
        <p className="text-gray-400 text-lg max-w-2xl mx-auto">
          Our dedicated coach brings world-class experience and passion to help
          every student reach their full potential.
        </p>
      </div>

      {/* ✅ Auto-adjust layout */}
      <div
        className={`px-4 ${
          coaches.length === 1
            ? "flex justify-center max-w-4xl mx-auto"
            : "grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-start"
        }`}
      >
        {coaches.map((coach, index) => (
          <Card
            key={index}
            className="bg-red-600 border-white/20 overflow-hidden w-full"
          >
            <CardContent className="p-0">
              <div className="relative">
                 <img
                    src={coach.image}
                    alt={coach.name}
                    className="w-full aspect-square object-cover object-top"
                  />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <h3 className="text-2xl font-bold text-white mb-1">
                    {coach.name}
                  </h3>
                  <p className="text-red-400 font-semibold">{coach.title}</p>
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-300 text-lg leading-relaxed mb-6 whitespace-pre-line">
                  {coach.description}
                </p>

                <div>
                  <h4 className="text-black font-semibold mb-3">
                    Specializes in:
                  </h4>
                  <div className="grid grid-cols-2 gap-2">
                    {coach.specialties.map((specialty, specialtyIndex) => (
                      <div
                        key={specialtyIndex}
                        className="flex items-center"
                      >
                        <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                        <span className="text-gray-300 text-sm">
                          {specialty}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
